import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// MUI Components
import MuiPagination from "@mui/lab/Pagination";
import PaginationItem from "@mui/lab/PaginationItem";

// Assets
import {blueColor, greyishBlue200, greyishBlue50, greyishBlue500} from "assets/jss/main";
import {ReactComponent as ArrowRight} from "assets/img/wms/arrow-right-pagination.svg";
import {ReactComponent as ArrowLeft} from "assets/img/wms/arrow-left-pagination.svg";

Pagination.propTypes = {
    pageCount: PropTypes.number.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    onClickPrevious: PropTypes.func,
    onClickNext: PropTypes.func
};

function Pagination({pageCount, onClickPrevious = () => {}, onClickNext = () => {}, handlePageChange = (page) => {}, props}) {
    const [currentPage, setCurrentPage] = React.useState(1);

    const ArrowBackIcon = () => (
        <ArrowLeft
            onClick={onClickPrevious}
            width={'16px'}
            height={'16px'}
        />
    )

    const ArrowNextIcon = () => (
        <ArrowRight
            onClick={onClickNext}
            width={'16px'}
            height={'16px'}
        />
    )

    return (
        <div style={{
            paddingBottom: '16px',
            background: '#FFF',
            paddingTop: '32px',
        }}>
            <MuiPagination
                count={pageCount}
                color="primary"
                shape="rounded"
                onChange={ (event, page) => {
                    setCurrentPage(page);
                    handlePageChange(page)
                }}
                sx={{
                    margin: 'auto',
                    textAlign: 'center',
                    'ul': {
                        display: 'flex',
                        justifyContent: 'center'
                    }
                }}
                renderItem={(item) => (
                    <PaginationItem
                        sx={{
                            fontWeight: 600,
                            color: greyishBlue500,
                            '&.MuiPaginationItem-ellipsis': {
                                fontWeight: 600,
                                color: greyishBlue500,
                            },
                            '&.MuiPaginationItem-previousNext' : {
                                opacity: 1,
                                marginLeft: '48px',
                                marginRight: '48px',
                                background: greyishBlue50,
                                '&.Mui-disabled' : {
                                    'svg path': {
                                        stroke: greyishBlue200
                                    }
                                },
                                'svg path': {
                                    stroke: greyishBlue500
                                }
                            },
                            '&.Mui-selected': {
                                background: blueColor,
                                color: '#fff',
                            }
                        }}
                        slots={{ previous: ArrowBackIcon,next: ArrowNextIcon}}
                        {...item}
                    />
                )}
                {...props}
            />
            <div style={{
                textAlign: 'center',
                color: greyishBlue500,
                fontSize: '12px',
                marginTop: '16px'
            }}>
                <FormattedMessage
                    id='wms.component.pagination.page'
                    values={{
                        page: currentPage,
                        totalPages: pageCount
                    }}
                />
            </div>
        </div>
    );
}

export default Pagination;
